import { useRouter } from "next/router";
import { BlueLink } from "../BlueLink";

export const NoticeTextEn = (props) => {
  return (
    <div {...props}>
      1.You can use this function to allow your friends to use the works related
      to the NFTs you hold as platform avatars or emoticons within a certain
      period. You understand and confirm that this function only provides an
      authorization to use the underlying works of NFT and does not involve any
      on-chain transfer of NFT.
      <br />
      2.Each NFT can only be authorized to one ID account at a time, and
      multiple NFTs can be authorized to the same ID account. You can cancel the
      authorization on this page at any time. After canceling the authorization,
      your friend’s ID account will not be able to continue to use the works
      related to the NFTs on the cooperative platform.
      <br />
      3.This function only supports some NFT series and some cooperative
      platforms, please refer to this page for details. You understand and
      confirm that, subject to the rules of NFT and cooperation platforms, the
      specific services of this function for different NFTs or different
      cooperation platforms may be different.
      <br />
      4.You understand and confirm that you or your friends will not use this
      function to carry out any profit-making activities or engage in any
      behavior that violates laws and regulations, third-party cooperation
      platform rules, NFT issuer rules or violates the legitimate rights and
      interests of third parties.
      <br />
      5.To provide you with this function, we need to provide the cooperative
      platform with the works related to the NFTs you hold, the information on
      the blockchain related to the NFTs you hold and the ID account of your
      friend on the designated cooperative platform. You understand and confirm
      that we will protect personal information and personal privacy in
      accordance with the&nbsp;
      <BlueLink href="/pdf/pp.pdf">Privacy Policy</BlueLink>
      &nbsp;and use the aforementioned information only for the purpose of
      providing this function.
      <br />
      6.You understand and confirm that, if ① the NFT is transferred on the
      blockchain, ② there is an abnormality with the authorized ID account
      within cooperative platform, ③ you or your friend violates this
      authorization notice, ④ we terminate the cooperative relationship with the
      cooperative platform and NFT issuer, ⑤ regulatory policy changes and other
      force majeure factors, ⑥ the business strategy changes of CryptoNatty,
      cooperative platform or NFT issuer, ⑦other reasons that may cause this
      function to be unavailable, we will not be able to continue to provide
      this function to you, and we do not assume any responsibility for this.
    </div>
  );
};

export const NoticeTextCn = (props) => {
  return (
    <div {...props}>
      1.您可以通过本功能，许可您的好友于一定期限内在合作平台使用您持有的NFT底层作品作为平台头像或者表情包。您理解并确认，本功能只提供一项NFT底层作品的使用授权，不涉及任何NFT的链上转移。授权NFT使用权后也会同时授权该NFT的部分权益的使用权。
      <br />
      2.每个NFT每次只能授权一个账号ID，多个NFT可以授权同一个账号ID。您可以随时在本页面解除授权，解除授权后您的好友账号ID将无法在合作平台继续使用NFT底层作品。
      <br />
      3.本功能目前仅支持部分NFT系列以及部分合作平台，具体请以本页面展示为准。您理解并确认，受限于NFT以及合作平台规则，本功能针对不同NFT或不同合作平台的具体服务可能存在差别。
      <br />
      4.您理解并确认，您或您的好友不得利用本功能开展任何营利活动或从事任何违反法规政策、第三方合作平台规则、NFT发行方规则或侵犯第三方合法权益的行为。
      <br />
      5.为了向您提供本功能，我们需要向合作平台提供您的NFT底层作品、NFT链上信息及您好友在指定合作平台的账号ID。您理解并确认，我们将根据&nbsp;
      <BlueLink href="/pdf/pp.pdf">Privacy Policy</BlueLink>
      &nbsp;保护个人信息及个人隐私，仅限提供本功能之目的使用前述信息。
      <br />
      6.您理解并确认，如①NFT发生链上转移，②授权好友账号存在异常，③您或您的好友违反本授权须知，④我们与合作平台、NFT发行方终止合作关系，⑤出现法规政策调整等不可抗力事由，⑥CryptoNatty、合作平台或NFT发行方的经营策略发生变更，⑦其他可能导致本功能无法提供的事由时，我们将无法继续向您提供本功能，且我们不因此承担任何责任。
    </div>
  );
};

export const Notice = () => {
  const { locale } = useRouter();
  return (
    <div className="max-w-[940px]">
      {locale === "en" && (
        <>
          <div className="font-black mt-[24px] mb-[8px]">Terms of Use</div>
          <div className="font-light text-[12px] leading-[20px]">
            <NoticeTextEn />
          </div>
        </>
      )}

      <div className="font-medium mt-[24px] mb-[8px]">授权须知</div>
      <div className="font-light text-[12px] leading-[20px]">
        <NoticeTextCn />
      </div>
    </div>
  );
};
